/* ==========================================================================
   FRONT PORCH SPORTS — homepage interactions
   Vanilla JS, no dependencies. Each block is independent, so any of them can
   be dropped when the matching Shopify section takes over that behaviour.
   ========================================================================== */
(function () {
  'use strict';

  var quickAddRepoint;   // set by the quick-add block below

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };


  /* --------------------------------------------- 0. Horizon layout variables
     Horizon's layout script measures its own <header-component> to set
     --header-height / --header-group-height. We replace that header, so its
     script returns early and those variables never get set — leaving Horizon's
     calc() rules on product/collection/cart pages with an invalid value.
     fps-styles.css ships defaults; this replaces them with real measurements. */
  (function headerMetrics() {
    var header = $('.header');
    if (!header) return;

    function measure() {
      var group = 0;
      var ann = $('.section-announcement-bar');
      if (ann) group += ann.offsetHeight;
      var h = header.offsetHeight;
      document.body.style.setProperty('--header-height', h + 'px');
      document.body.style.setProperty('--header-group-height', (group + h) + 'px');
      document.body.style.setProperty('--top-row-height', h + 'px');
      document.body.style.setProperty('--transparent-header-offset-boolean', '0');
    }

    measure();
    window.addEventListener('resize', measure);
    if (window.ResizeObserver) new ResizeObserver(measure).observe(header);
  })();


  /* ------------------------------------------------ 1. Announcement rotator
     Cycles .announcement__slide. Static if the visitor prefers reduced motion
     or there is only one message. */
  (function announcementBar() {
    var wrap = $('#js-announcement');
    if (!wrap) return;
    var slides = $$('.announcement__slide', wrap);
    if (slides.length < 2 || reduceMotion) return;

    var i = 0;
    setInterval(function () {
      slides[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % slides.length;
      slides[i].setAttribute('aria-hidden', 'false');
    }, 5000);
  })();


  /* ------------------------------------------------------- 2. Mobile drawer
     Slides the nav in from the left, locks the page behind it, and traps Esc.
     Desktop (>=768px) ignores all of this — the nav is inline there. */
  (function mobileNav() {
    var trigger = $('#js-nav-trigger');
    var nav     = $('#js-nav');
    var closeBtn= $('#js-nav-close');
    var overlay = $('#js-overlay');
    if (!trigger || !nav) return;

    function open() {
      document.body.classList.add('nav-active', 'lock-scroll', 'overlay-open');
      trigger.setAttribute('aria-expanded', 'true');
      trigger.setAttribute('aria-label', 'Close menu');
      if (overlay) overlay.hidden = false;
    }
    function close() {
      document.body.classList.remove('nav-active', 'lock-scroll', 'overlay-open');
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-label', 'Open menu');
      if (overlay) overlay.hidden = true;
      closeSubNav();
    }
    function toggle() {
      document.body.classList.contains('nav-active') ? close() : open();
    }

    trigger.addEventListener('click', toggle);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay)  overlay.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (nav.classList.contains('sub-nav-active')) { closeSubNav(); return; }
      if (document.body.classList.contains('nav-active')) close();
    });

    // leaving mobile width with the drawer open would strand the lock
    window.matchMedia('(min-width: 768px)').addEventListener('change', function (e) {
      if (e.matches) close();
    });

    function closeSubNav() {
      nav.classList.remove('sub-nav-active');
      $$('.sub-nav', nav).forEach(function (s) { s.classList.remove('is-open'); });
      $$('.parent-anchor', nav).forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    }
    mobileNav.closeSubNav = closeSubNav;
  })();


  /* ---------------------------------------------------------- 3. Mega menu
     Mobile: tapping a parent slides its panel in from the right.
     Desktop: CSS handles hover; this adds click/keyboard parity. */
  (function megaMenu() {
    var nav = $('#js-nav');
    if (!nav) return;
    var desktop = window.matchMedia('(min-width: 768px)');

    $$('.item-parent[data-has-sub]', nav).forEach(function (item) {
      var btn = $('.parent-anchor', item);
      var sub = $('.sub-nav', item);
      var back= $('.back-anchor', item);
      if (!btn || !sub) return;

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (desktop.matches) {
          var isOpen = btn.classList.contains('open');
          $$('.parent-anchor', nav).forEach(function (b) {
            b.classList.remove('open');
            b.setAttribute('aria-expanded', 'false');
          });
          if (!isOpen) { btn.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); }
        } else {
          nav.classList.add('sub-nav-active');
          sub.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          var first = $('.sub-anchor-parent, .back-anchor', sub);
          if (first) first.focus({ preventScroll: true });
        }
      });

      if (back) back.addEventListener('click', function () {
        nav.classList.remove('sub-nav-active');
        sub.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        btn.focus({ preventScroll: true });
      });
    });

    // click-away closes any open desktop panel
    document.addEventListener('click', function (e) {
      if (!desktop.matches || nav.contains(e.target)) return;
      $$('.parent-anchor', nav).forEach(function (b) {
        b.classList.remove('open');
        b.setAttribute('aria-expanded', 'false');
      });
    });
  })();


  /* ----------------------------------------------------------- 4. Carousel
     Old Row loads slick.js but the category rail is really a native scroll
     container, so this uses the same mechanism: scroll-behavior:smooth for
     the easing, arrows that page by one item, and pointer drag-to-scroll.
     A drag past the threshold suppresses the click so you don't navigate. */
  $$('[data-carousel]').forEach(function (root) {
    var track = $('[data-carousel-track]', root);
    var prev  = $('[data-carousel-prev]', root);
    var next  = $('[data-carousel-next]', root);
    if (!track) return;

    function step() {
      var item = $('.carousel__item', track);
      if (!item) return track.clientWidth * 0.8;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function syncArrows() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= max;
    }

    function scrollBy(dir) {
      track.scrollBy({ left: dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });

    track.addEventListener('scroll', syncArrows, { passive: true });
    window.addEventListener('resize', syncArrows);
    // images are lazy — recheck once they have real dimensions
    window.addEventListener('load', syncArrows);
    syncArrows();

    /* drag-to-scroll */
    var down = false, startX = 0, startScroll = 0, moved = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;   // native touch scrolling is better
      down = true; moved = 0;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.setPointerCapture(e.pointerId);
    });

    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) track.classList.add('is-dragging');
      moved = Math.max(moved, Math.abs(dx));
      track.scrollLeft = startScroll - dx;
    });

    function endDrag(e) {
      if (!down) return;
      down = false;
      try { track.releasePointerCapture(e.pointerId); } catch (err) {}
      // let the class linger one frame so the click lands on a dead element
      requestAnimationFrame(function () { track.classList.remove('is-dragging'); });
    }
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener('click', function (e) {
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); }
      moved = 0;
    }, true);
  });


  /* -------------------------------------------------- 5. Footer accordion
     Mobile only; at >=1024px CSS shows every column expanded and the
     togglers become inert, so guard on the media query. */
  (function footerAccordion() {
    var desktop = window.matchMedia('(min-width: 1024px)');
    $$('.footer-top .toggler').forEach(function (btn) {
      var wrap = btn.closest('.col') && $('.toggle-wrap', btn.closest('.col'));
      if (!wrap) return;
      btn.addEventListener('click', function () {
        if (desktop.matches) return;
        var open = wrap.classList.toggle('active');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  })();


  /* -------------------------------------------------------- 6. Load more
     Reveals the next batch of hidden product cards and keeps the
     "N of M products" counter honest. */
  (function loadMore() {
    var btn  = $('#js-load-more');
    var grid = $('#js-product-grid');
    var shown= $('#js-shown');
    if (!btn || !grid) return;
    var BATCH = 8;

    btn.addEventListener('click', function () {
      var hidden = $$('.product-card.is-hidden', grid);
      hidden.slice(0, BATCH).forEach(function (c) { c.classList.remove('is-hidden'); });

      var visible = $$('.product-card', grid).length - $$('.product-card.is-hidden', grid).length;
      if (shown) shown.textContent = visible;

      if (!$('.product-card.is-hidden', grid)) {
        btn.parentNode.removeChild(btn);
      }
    });
  })();


  /* ------------------------------------------------------ 7. Colour swatches */
  $$('.product-card__colors').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var sw = e.target.closest('.swatch');
      if (!sw || !group.contains(sw)) return;
      $$('.swatch', group).forEach(function (s) { s.classList.remove('active'); });
      sw.classList.add('active');
      var card = group.closest('.product-card');
      if (card && typeof quickAddRepoint === 'function') quickAddRepoint(card);
    });
  });


  /* ------------------------------------------- 8. Quick add + cart counter
     Posts to Shopify's /cart/add.js. The card carries a JSON variant map so a
     colour swatch change re-resolves which variant each size button adds — the
     buttons are rendered against the first colour at build time. */
  (function quickAdd() {
    var count = $('#js-cart-count');
    var cart  = $('#js-cart');
    var toast = $('#js-toast');
    var toastTimer;

    function say(msg) {
      if (!toast) return;
      toast.textContent = msg;
      toast.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2600);
    }

    function setCount(n) {
      if (count) {
        count.textContent = n;
        count.classList.toggle('hide', !n);
      }
      if (cart) cart.classList.toggle('cart--active', !!n);
    }

    function cardData(card) {
      var el = card && card.querySelector('.product-card__data');
      if (!el) return null;
      try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }

    /* re-point size buttons at the variants for the newly selected colour */
    function repointSizes(card) {
      var data = cardData(card);
      if (!data) return;
      var active = card.querySelector('.product-card__colors .swatch.active');
      var color  = active && active.getAttribute('data-color');
      if (!color) return;

      $$('.product-card__options .option', card).forEach(function (btn) {
        var size = btn.getAttribute('data-size');
        var match = data.variants.filter(function (v) {
          return v.options.indexOf(color) > -1 && v.options.indexOf(size) > -1;
        })[0];
        if (!match) return;
        btn.setAttribute('data-variant-id', match.id);
        btn.setAttribute('data-available', match.available);
        btn.disabled = !match.available;
      });

      var single = card.querySelector('.product-card__options--single .add-to-cart');
      var cta    = card.querySelector('.product-card__cta .add-to-cart');
      var first  = data.variants.filter(function (v) {
        return v.options.indexOf(color) > -1 && v.available;
      })[0];
      if (first) {
        if (single) single.setAttribute('data-variant-id', first.id);
        if (cta)    cta.setAttribute('data-variant-id', first.id);
      }
    }
    quickAddRepoint = repointSizes;

    document.addEventListener('click', function (e) {
      var el = e.target.closest('.product-card__options .option, .add-to-cart');
      if (!el) return;
      if (el.getAttribute('data-available') === 'false' || el.disabled) return;
      e.preventDefault();

      var id = el.getAttribute('data-variant-id');
      if (!id) return;

      var card = el.closest('.product-card');
      var name = el.getAttribute('data-product')
              || (card && $('.product-card__title', card) || {}).textContent
              || 'Item';
      var size = el.classList.contains('option') ? ' (' + el.textContent.trim() + ')' : '';

      el.classList.add('is-loading');
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) {
            say(res.body && res.body.description ? res.body.description : 'Could not add that one');
            return;
          }
          say('Added ' + name.trim() + size);
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (c) { setCount(c.item_count); });
        })
        .catch(function () { say('Could not reach the cart'); })
        .then(function () { el.classList.remove('is-loading'); });
    });
  })();


  /* ------------------------------------------------------- 9. Newsletter */
  (function newsletter() {
    var form = $('#js-newsletter');
    if (!form) return;
    var input = $('input[type=email]', form);
    var msg   = $('.js-newsletter-msg', form);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var val = (input.value || '').trim();
      var ok  = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val);
      if (!msg) return;
      msg.classList.toggle('is-error', !ok);
      msg.textContent = ok ? "You're on the list. Watch your inbox." : 'Enter a valid email address.';
      if (ok) form.reset();
    });
  })();

})();
